$(document).ready(function () {
    $('#savepersonalfile').on('show.bs.modal', function () {
        var modal = $(this);
        var upload_form = $(modal).find('form');
        $(upload_form).validate({
            ignore: ':hidden, [contenteditable="true"]:not([name])',
            debug: false,
            errorClass: 'danger',
            rules: {
                userfile: { required: true },
                title: { required: true },
            },
            submitHandler: function (form) {
                form.submit();
            },
        });
    });
});
